import { useEffect, useRef, MutableRefObject } from 'react';

type OuterRef<T> =
	| ((instance: T | null) => void)
	| MutableRefObject<T | null>
	| null;

/**
 * Allows reusing a forwarded ref internally
 * See: https://itnext.io/reusing-the-ref-from-forwardref-with-react-hooks-4ce9df693dd
 */
export function useForwardRef<T>(outerRef: OuterRef<T>) {
	const innerRef = useRef<T | null>(null);

	useEffect(() => {
		if (!outerRef) {
			return;
		}

		if (!innerRef) {
			return;
		}

		if (typeof outerRef === 'function') {
			outerRef(innerRef.current);
		} else {
			// eslint-disable-next-line no-param-reassign
			outerRef.current = innerRef.current;
		}
	}, [outerRef, innerRef]);

	return innerRef;
}
